import { Component } from '@angular/core';
import { SexualPerformanceComponent } from '@consultation-upsells/sexual-performance/sexual-performance.component';

@Component({
  selector: 'app-sexual-performance-trt',
  imports: [SexualPerformanceComponent],
  templateUrl: './sexual-performance-trt.component.html',
})
export class SexualPerformanceTrtComponent {}
